"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subStateMatchHelper = exports.pendingStateMatchHelper = exports.canceledStateMatchHelper = exports.convertAppointment = exports.hasProvider = void 0;
const xstate_1 = require("./constants/xstate");
/**
 * Function that determines whether or not a provider exists and returns a boolean
 *
 * @param {} provider
 * @return boolean
 */
const hasProvider = (provider) => Object.keys(provider).length !== 0;
exports.hasProvider = hasProvider;
/**
 * Function to take a backend appointment and strip it down to only the
 * necessary portions for the machine's context
 *
 * @param responseData The appointment response data in backend format. It contains the appointment and capabilities objects.
 * @returns An object containing appointmentId, appointment, location, and providerId,
 *          to be inserted into the machines context
 */
const convertAppointment = (responseData) => {
    var _a;
    if (!responseData) {
        return {};
    }
    const { appointment: originalAppointment = {
        location: { address: {} },
        provider: {}
    }, capabilities = { cancel: { enabled: true } } } = responseData;
    const { id: appointmentId = '', location: { location_pma_id: locationId = 0 }, patient_relationship: patientRelationship = '', provider: { provider_pma_id: providerId = 0 }, purpose_name: patientPurpose = '', start_datetime: startDateTime = '', latest_cancellation: latestCancellation = '', status = '' } = originalAppointment;
    const { cancel: { enabled: isCancelEnabled }, reschedule = { enabled: true } } = capabilities;
    return {
        appointmentId,
        appointment: {
            patientPurpose,
            patientRelationship,
            status,
            startDateTime,
            latestCancellation,
            isCancelEnabled,
            isRescheduleEnabled: (_a = reschedule === null || reschedule === void 0 ? void 0 : reschedule.enabled) !== null && _a !== void 0 ? _a : true
        },
        locationId,
        providerId
    };
};
exports.convertAppointment = convertAppointment;
/**
 * Helper function to determine when the state machine is in one of the states reflecting a canceled appointment
 * (`confirmationPage` or `canceledPreviously`)
 *
 * @param state xstate state object
 * @returns boolean Whether the state machine is in a canceled appointment context
 */
const canceledStateMatchHelper = (state) => {
    return (state &&
        (state.matches(xstate_1.states.confirmationPage) ||
            state.matches(xstate_1.states.canceledPreviously)));
};
exports.canceledStateMatchHelper = canceledStateMatchHelper;
/**
 * Helper function to determine when the state machine is in one of the loading states
 * (`appointment` or `provider`) but not in an error state
 *
 * @param state xstate state object
 * @returns boolean Whether the state machine is in a pending context
 */
const pendingStateMatchHelper = (state) => {
    return (state &&
        (state.matches(xstate_1.states.appointment) || state.matches(xstate_1.states.provider)) &&
        !(0, exports.subStateMatchHelper)(xstate_1.states.error, state));
};
exports.pendingStateMatchHelper = pendingStateMatchHelper;
/**
 * Helper function to determine when the state machine is in a given substate
 *
 * @param subState xstate substate (e.g. "@state/CANCEL_DISABLED_PAGE")
 * @param state the entire xstate state object
 * @returns boolean Whether the state machine is in a given substate
 */
const subStateMatchHelper = (subState, state) => {
    return state && Object.values(state.value).includes(subState);
};
exports.subStateMatchHelper = subStateMatchHelper;
//# sourceMappingURL=utils.js.map